import { Controller } from "@hotwired/stimulus"

// Controls the collapsible generation context form section
// and updates the style description based on selection
export default class extends Controller {
  static targets = ["content", "icon", "articleStyle", "styleDescription"]
  static values = {
    expanded: { type: Boolean, default: false }
  }

  // Style descriptions matching DraftArticle::ARTICLE_STYLES
  static styleDescriptions = {
    blog: "Conversational, engaging personal or company blog post",
    interview: "Q&A format with questions and detailed answers",
    reporting: "Factual, objective journalistic reporting",
    story: "Narrative storytelling with a beginning, middle, and end",
    listicle: "List-based article (e.g., \"10 Ways to...\")",
    how_to: "Step-by-step instructional content",
    comparison: "Side-by-side comparison of options or products",
    explainer: "Deep-dive explanation of a concept or topic",
    opinion: "Persuasive piece expressing a viewpoint",
    case_study: "Detailed analysis of a specific example or scenario"
  }

  connect() {
    this.updateIcon()

    // Add event listener for style changes
    if (this.hasArticleStyleTarget) {
      this.articleStyleTarget.addEventListener("change", this.updateStyleDescription.bind(this))
    }
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    this.updateVisibility()
    this.updateIcon()
  }

  updateVisibility() {
    if (this.hasContentTarget) {
      this.contentTarget.style.display = this.expandedValue ? "block" : "none"
    }
  }

  updateIcon() {
    if (this.hasIconTarget) {
      if (this.expandedValue) {
        this.iconTarget.classList.add("rotate-180")
      } else {
        this.iconTarget.classList.remove("rotate-180")
      }
    }
  }

  updateStyleDescription() {
    if (!this.hasArticleStyleTarget || !this.hasStyleDescriptionTarget) return

    const selectedStyle = this.articleStyleTarget.value
    const description = this.constructor.styleDescriptions[selectedStyle] || "Choose a style to see its description"
    this.styleDescriptionTarget.textContent = description
  }

  expandedValueChanged() {
    this.updateVisibility()
    this.updateIcon()
  }
}
